/**
 * Captures a JPEG screenshot of the current viewport for the dashboard help chat.
 * Excludes the help chat popover so the image reflects the page behind it.
 */
export async function captureHelpChatViewportScreenshotJpegBase64(): Promise<string> {
    const html2canvas = (await import('html2canvas')).default;
    const w = Math.max(1, window.innerWidth);
    const canvas = await html2canvas(document.body, {
        ignoreElements: (element) => element.closest('[data-testid="help-chat-balloon"]') != null,
        scale: Math.min(0.65, 1400 / w),
        useCORS: true,
        logging: false,
        scrollX: -window.scrollX,
        scrollY: -window.scrollY,
        windowWidth: document.documentElement.clientWidth,
        windowHeight: window.innerHeight,
    });
    const dataUrl = canvas.toDataURL('image/jpeg', 0.82);
    const prefix = 'data:image/jpeg;base64,';
    if (!dataUrl.startsWith(prefix)) {
        throw new Error('screenshot_encode_failed');
    }
    return dataUrl.slice(prefix.length);
}
